import { memo } from "react";
import { LuStore } from "react-icons/lu";

/** Which store's listings and prices the shop shows. */
function StorePicker({ stores, storeId, onChoose }) {
  if (!stores.length) return null;
  return (
    <label className="ep-store-picker">
      <LuStore aria-hidden="true" />
      <span className="ep-visually-hidden">Store</span>
      <select value={storeId ?? ""} onChange={(e) => onChoose(Number(e.target.value))} aria-label="Choose store">
        {stores.map((store) => (
          <option key={store.id} value={store.id}>
            {store.name} — {store.city}
          </option>
        ))}
      </select>
    </label>
  );
}

export default memo(StorePicker);
